const FontsSizesFoundationsThemes = {
    font_size_heading_xllm_display_xl: '4rem',
    font_size_heading_xllm_display_1: '3.375rem',
    font_size_heading_xllm_display_2: '3rem',
    font_size_heading_xllm_h1: '1.75rem',
    font_size_heading_xllm_h2: '1.5rem',
    font_size_heading_s_display_1: '2.625rem',
    font_size_heading_s_display_2: '1.75rem',
    font_size_heading_s_h1: '1.5rem',
    font_size_heading_s_h2: '1.25rem',
    font_size_heading_title_ds: '1.25rem',
    font_size_heading_title_ds_50: '1.25rem',
    font_size_paragraph_large: '1.125rem',
    font_size_paragraph_medium: '1rem',
    font_size_paragraph_small: '0.875rem',
    font_size_caption_medium: '0.75rem',
    font_size_caption_small: '0.625rem',
};
export { FontsSizesFoundationsThemes };
//# sourceMappingURL=fonts-sizes-foundations.themes.js.map